// extracted by mini-css-extract-plugin
export var phone = "_2v-0";